



function ysetCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function ygetCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return decodeURIComponent(parts.pop().split(";").shift());
}

// Set cookies for 'make' and 'model'
function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000); // Set expiry in days
  const expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
// Get cookie value by name
function getCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null; // Return null if the cookie is not found
}

function handleize(str) {
  if (typeof str !== 'string') {
    console.error("Error: Input to handleized function is not a string:", str);
    return ''; // Or some other appropriate default value or error handling
  }  
  return str
    .normalize("NFD") // Normalize to decompose accented characters
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritic marks
    .toLowerCase() // Convert to lowercase
    .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric characters with hyphens
    .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
}

function handleizeLast(str) {
  if (typeof str !== 'string') {
    console.error("Error: Input to handleized function is not a string:", str);
    return ''; // Or some other appropriate default value or error handling
  }
  return str
    .normalize("NFD") // Normalize to decompose accented characters
    .replace(/[\u0300-\u036f]/g, "") // Remove diacritic marks
    .toLowerCase() // Convert to lowercase
    .replace(/\./g, "") // Remove periods
    .replace(/[^a-z0-9]+/g, "-") // Replace non-alphanumeric characters with hyphens
    .replace(/^-+/, ""); // Remove leading hyphens only
}


function updateDisplay(inputSelector, displayElementId) {
  const inputs = document.querySelectorAll(inputSelector);
  const displayElement = document.getElementById(displayElementId);

  function update() {
    inputs.forEach((input) => {
      if (input.checked) {
        displayElement.textContent = input.value;
      }
    });
  }

  inputs.forEach((input) => {
    input.addEventListener("change", update);
  });

  update(); // Initial update
}


function cleanString(text) {
  let cleaned = text.toLowerCase();

  cleaned = cleaned.replace(/["'_\/()]/g, ""); // Remove quotes, underscores, slashes, parentheses
  cleaned = cleaned.replace(/\+/g, "-"); // Replace plus with dash
  cleaned = cleaned.replace(/\s/g, "-"); // Replace spaces with dash
  cleaned = cleaned.replace(/\./g, ""); // Remove periods, not replace with dash
  cleaned = cleaned.replace(/-+/g, "-"); // Replace multiple dashes with single dash

  return cleaned;
}

function attachDelayedChangeListener(selector, callback, delay = 300) {
  const elements = document.querySelectorAll(selector);
  if (elements) {
    elements.forEach((element) => {
      element.addEventListener("change", () => {
        setTimeout(callback, delay);
      });
    });
  }
}

function shortenMake(handle, makeLong, makeShort) {
  return handle.replace(new RegExp(makeLong, "g"), makeShort);
}



function saveToIndexedDB(dbName, storeName, key, value) {
  // First, open the database WITHOUT specifying a version (use existing version)
  const openRequest = indexedDB.open(dbName);

  openRequest.onsuccess = (event) => {
    const db = event.target.result;

    // If object store doesn't exist, we need to upgrade the DB
    if (!db.objectStoreNames.contains(storeName)) {
      const version = db.version + 1;
      db.close();

      const upgradeRequest = indexedDB.open(dbName, version);

      upgradeRequest.onupgradeneeded = (event) => {
        const upgradedDB = event.target.result;
        upgradedDB.createObjectStore(storeName);
      };

      upgradeRequest.onsuccess = () => {
        saveToIndexedDB(dbName, storeName, key, value); // Retry after creating store
      };

      upgradeRequest.onerror = (e) => {
        console.error("Upgrade error:", e.target.error);
      };
    } else {
      const tx = db.transaction(storeName, "readwrite");
      const store = tx.objectStore(storeName);
      store.put(value, key);
      tx.oncomplete = () => {
        console.log("Data saved successfully");
      };
      tx.onerror = (e) => {
        console.error("Transaction error:", e.target.error);
      };
    }
    document.querySelector(
      ".section_filter-metaobject .holster-option"
    ).style.display = "none";

    // setCookie("holster_load_flag", true, 7); // The 'make' cookie will expire in 7 days
  };

  openRequest.onerror = (event) => {
    console.error("Open DB error:", event.target.error);
  };
}

function getFromIndexedDB(dbName, storeName, key, callback) {
  // Open the database
  const openRequest = indexedDB.open(dbName);

  openRequest.onsuccess = (event) => {
    const db = event.target.result;

    // Start a transaction
    const tx = db.transaction(storeName, "readonly");
    const store = tx.objectStore(storeName);

    // Fetch the item using the key
    const getRequest = store.get(key);

    getRequest.onsuccess = (e) => {
      const result = e.target.result;
      callback(result); // Pass the result to callback
    };

    getRequest.onerror = (e) => {
      console.error("Get request error:", e.target.error);
      callback(null); // Handle errors by passing null
    };

    tx.oncomplete = () => {
      db.close();
    };
  };

  openRequest.onerror = (event) => {
    console.error("Open DB error:", event.target.error);
  };
}

document.addEventListener("DOMContentLoaded", function () {});

    
// Function to remove a cookie by its name
function removeCookie(cookieName) {
  // Set the cookie with an expired date to delete it
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;

  document.cookie.split(";").forEach(function(c) {
    document.cookie = c.trim().split("=")[0] + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/";
  });
}


    function removeBrackets(str) {
        return str.replace(/^\["|"\]$/g, '');
    }


        function checkAndDisableAddToCartButtons() {
           const error_msg = 'Please select weapon make/model to add to cart';
      
        if (!getCookie("uch_model")) {
          const buttons = document.querySelectorAll(".add-to-cart");
 
          buttons.forEach(button => {
            button.disabled = true;
             if(!document.querySelector(".no-model-set")){
                  const errorDiv = document.createElement("div");
                  errorDiv.className = "no-model-set";
                  errorDiv.textContent = error_msg;
                  button.parentNode.insertBefore(errorDiv, button);
             }
              button.disabled = true;
          });

          const bundle = document.querySelector(".bundler-target-element");
          if(bundle){
              bundle.classList.add('bndlr-disabled');
                  if(!document.querySelector(".no-model-set-bundle")){
                    console.log('not there');
                        const errorBundle = document.createElement("div");
                    errorBundle.className = "no-model-set-bundle";
                    errorBundle.textContent = error_msg;
                    bundle.parentNode.insertBefore(errorBundle, bundle);
                  } else {
 
                  }
          }
        }
      }
